import { createIcon } from '../shared'

const AiInfoIcon = createIcon(
  ({ color }) => (
    <>
      <path
        d="M20.5 11L20.5 16A4.5 4.5 0 0 1 16 20.5L8 20.5A4.5 4.5 0 0 1 3.5 16L3.5 8A4.5 4.5 0 0 1 8 3.5L13 3.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17 3.4L17.74 6.26L20.6 7L17.74 7.74L17 10.6L16.26 7.74L13.4 7L16.26 6.26Z"
        fill={color}
      />
    </>
  ),
  '0 0 24 24',
  'AiInfoIcon',
)

export { AiInfoIcon }
